class SalesRegisterModel {
  SalesRegisterId = null;
  EnquiryId = null;
  SalesDate = '';
  CustomerName = '';
  MobileNumber = '';
  EmailId = '';
  Remarks = '';
  SalesRegisterDetails = [];
}

export default SalesRegisterModel;
